module.exports = __webpack_public_path__ + "img/phone-call.356187cc.svg";